module.exports = __webpack_public_path__ + "static/media/logout.56e03b7d.svg";